import React from "react";
import classnames from "classnames";

export type IconType =
  | "back"
  | "image"
  | "call"
  | "mail"
  | "message"
  | "find"
  | "clear"
  | "edit"
  | "view"
  | "back-gray"
  | "close"
  | "edit-blue"
  | "edit-orange"
  | "delete"
  | "delete-white"
  | "download"
  | "back-white"
  | "chevron-orange"
  | "front-orange"
  | "lock"
  | "calendar"
  | "calendar-orange"
  | "close-black"
  | "menu"
  | "option-selected-green"
  | "menu-orange"
  | "chevron-top-blue"
  | "chevron-bottom-gray"
  | "document"
  | "marker"
  | "combined"
  | "check-dark"
  | "check-orange"
  | "check-green"
  | "check-blue"
  | "double-check-green"
  | "check-white"
  | "not-found"
  | "double-check-white"
  | "clock"
  | "warning"
  | "refresh"
  | "list-blue"
  | "list-grey"
  | "score-grey"
  | "letter"
  | "logout"
  | "logout-white"
  | "sort"
  | "sort-asc"
  | "sort-dsc"
  | "user"
  | "user-shadow"
  | "user-shadow-blue"
  | "eye"
  | "eye-close"
  | "white-cancel"
  | "file"
  | "users"
  | "chevron-left"
  | "upload-file"
  | "monitor-with-loupe"
  | "testing-valid"
  | "not-found-in-table"
  | "finished-file"
  | "minus-grey"
  | "nav-users"
  | "nav-home"
  | "nav-bag"
  | "nav-data-delivery"
  | "nav-pay-per-lead"
  | "nav-county-management"
  | "nav-claritas"
  | "nav-search-properties"
  | "logo"
  | "chevron-left-grey"
  | "chevron-right-grey"
  | "chevron-down-grey"
  | "get-output"
  | "get-original"
  | "generate-file"
  | "generate-file-blue"
  | "empty-screen"
  | "no-subscription"
  | "no-subscriptions"
  | "files-on-the-way"
  | "payment-failed"
  | "region-not-selected"
  | "auth-screen"
  | "code"
  | "nav-code"
  | "details"
  | "plus"
  | "plus-white"
  | "plus-grey"
  | "send"
  | "send-white"
  | "send-blue"
  | "dollar-black"
  | "unsend"
  | "files"
  | "blue-eye"
  | "sphere-blue"
  | "sphere-blue-crossed"
  | "arrow-bottom-grey"
  | "back-black-arrow"
  | "approve"
  | "decline"
  | "decline-blue"
  | "dispute"
  | "dispute-approved"
  | "dispute-declined"
  | "nav-market-map"
  | "nav-subscriptions"
  | "arrow-top-grey"
  | "reset-grey"
  | "reset-blue"
  | "get-original-grey"
  | "nav-records"
  | "wallet"
  | "wallet-grey"
  | "free-and-clear"
  | "off-market"
  | "high-equity"
  | "area"
  | "bathroom"
  | "bedroom"
  | "property"
  | "download"
  | "layers"
  | "email"
  | "chat"
  | "phone"
  | "filter-toggle"
  | "empty-property-records"
  | "empty-property-lists"
  | "calls-made"
  | "calls-check"
  | "offer"
  | "home-sold"
  | "investment"
  | "copy"
  | "star"
  | "star-blue"
  | "star-black"
  | "empty-general"
  | "nav-tickets"
  | "thumb-up"
  | "empty-tickets"
  | "empty-leads"
  | "nav-niche-files"
  | "nav-community"
  | "nav-external-link"
  | "reisift"
  | "nav-research";

export interface IconProps {
  type: IconType;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  title?: string;
}

export default function Icon(props: IconProps) {
  const { type, className, onClick, title } = props;
  return <div onClick={onClick} title={title} className={classnames("icon", className, type)} />;
}
